import { TIMEZONES_MAP } from './constants';

export const getTimezoneOptions = () =>
  Object.keys(TIMEZONES_MAP).map((value) => ({
    value,
    label: TIMEZONES_MAP[value],
  }));
